import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, ChangeDetectionStrategy, Inject, ViewChild, HostBinding, HostListener, EventEmitter, Optional, Input, Output, ContentChildren, Directive, NgModule } from '@angular/core';
import * as i6 from '@taiga-ui/cdk';
import { TUI_FOCUSABLE_ITEM_ACCESSOR, TUI_FONTS_READY, AbstractTuiInteractive, tuiIsNativeFocusedIn, tuiRetargetedBoundaryCrossing, tuiAsFocusableItemAccessor, tuiPure, TuiIdService, TuiFocusableModule, TuiAutofilledModule } from '@taiga-ui/cdk';
import * as i11 from '@taiga-ui/core/directives/hint';
import { TuiHintOptionsDirective } from '@taiga-ui/core/directives/hint';
import * as i10 from '@taiga-ui/core/directives/textfield-controller';
import { TUI_TEXTFIELD_WATCHED_CONTROLLER, TUI_TEXTFIELD_OPTIONS, TEXTFIELD_CONTROLLER_PROVIDER } from '@taiga-ui/core/directives/textfield-controller';
import { tuiGetBorder } from '@taiga-ui/core/utils/miscellaneous';
import * as i9 from '@tinkoff/ng-polymorpheus';
import { PolymorpheusOutletDirective, PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { BehaviorSubject, merge, fromEvent } from 'rxjs';
import { delay, filter, map, distinctUntilChanged } from 'rxjs/operators';
import * as i1 from '@taiga-ui/core/components/svg';
import { TuiSvgModule } from '@taiga-ui/core/components/svg';
import { TuiAppearance } from '@taiga-ui/core/enums';
import * as i3 from '@taiga-ui/core/components/tooltip';
import { TuiTooltipModule } from '@taiga-ui/core/components/tooltip';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@taiga-ui/core/directives/wrapper';
import { TuiWrapperModule } from '@taiga-ui/core/directives/wrapper';
import * as i7 from '@taiga-ui/core/directives/mask-accessor';
import { TuiMaskAccessorModule } from '@taiga-ui/core/directives/mask-accessor';
import * as i8 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { AbstractTuiTextfieldHost } from '@taiga-ui/core/abstract';
import { tuiAsTextfieldHost, TUI_TEXTFIELD_HOST, TUI_LEGACY_MASK } from '@taiga-ui/core/tokens';
import * as i1$1 from '@taiga-ui/core/directives';
import { TUI_TEXTFIELD_WATCHED_CONTROLLER as TUI_TEXTFIELD_WATCHED_CONTROLLER$1, TEXTFIELD_CONTROLLER_PROVIDER as TEXTFIELD_CONTROLLER_PROVIDER$1, TUI_TEXTFIELD_DEFAULT_OPTIONS, TUI_TEXTFIELD_OPTIONS as TUI_TEXTFIELD_OPTIONS$1, tuiTextfieldOptionsProvider } from '@taiga-ui/core/directives';
const _c0 = ["pre"];
const _c1 = ["focusableElement"];
const _c2 = [[["input"]], [["select"]], [["tuiContent"]], "*"];
const _c3 = ["input", "select", "tuiContent", "*"];
const _c4 = a0 => ({
  $implicit: a0
});
function TuiPrimitiveTextfieldComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TuiPrimitiveTextfieldComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TuiPrimitiveTextfieldComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
function TuiPrimitiveTextfieldComponent_div_12_tui_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-svg", 20);
  }
  if (rf & 2) {
    const src_r2 = ctx.polymorpheusOutlet;
    i0.ɵɵproperty("src", src_r2);
  }
}
function TuiPrimitiveTextfieldComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, TuiPrimitiveTextfieldComponent_div_12_tui_svg_1_Template, 1, 1, "tui-svg", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r2.iconLeftContent)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c4, ctx_r2.size));
  }
}
function TuiPrimitiveTextfieldComponent_label_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 21);
    i0.ɵɵprojection(1, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("t-placeholder_raised", ctx_r2.placeholderRaised);
    i0.ɵɵproperty("for", ctx_r2.computedId);
  }
}
function TuiPrimitiveTextfieldComponent_div_20_tui_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-svg", 24);
  }
  if (rf & 2) {
    const src_r4 = ctx.polymorpheusOutlet;
    i0.ɵɵproperty("src", src_r4);
  }
}
function TuiPrimitiveTextfieldComponent_div_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, TuiPrimitiveTextfieldComponent_div_20_tui_svg_1_Template, 1, 1, "tui-svg", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r2.controller.customContent);
  }
}
function TuiPrimitiveTextfieldComponent_span_21_tui_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-svg", 27);
  }
  if (rf & 2) {
    const src_r6 = ctx.polymorpheusOutlet;
    i0.ɵɵproperty("src", src_r6);
  }
}
function TuiPrimitiveTextfieldComponent_span_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵlistener("click.stop", function TuiPrimitiveTextfieldComponent_span_21_Template_span_click_stop_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clear());
    });
    i0.ɵɵtemplate(1, TuiPrimitiveTextfieldComponent_span_21_tui_svg_1_Template, 1, 1, "tui-svg", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r2.iconCleaner || ctx_r2.controller.options.iconCleaner)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c4, ctx_r2.size));
  }
}
function TuiPrimitiveTextfieldComponent_tui_tooltip_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-tooltip", 28);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("content", ctx_r2.hintOptions == null ? null : ctx_r2.hintOptions.content)("describeId", ctx_r2.computedId);
  }
}
function TuiPrimitiveTextfieldComponent_div_23_tui_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-svg", 20);
  }
  if (rf & 2) {
    const src_r7 = ctx.polymorpheusOutlet;
    i0.ɵɵproperty("src", src_r7);
  }
}
function TuiPrimitiveTextfieldComponent_div_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, TuiPrimitiveTextfieldComponent_div_23_tui_svg_1_Template, 1, 1, "tui-svg", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r2.iconContent)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c4, ctx_r2.size));
  }
}
const _c5 = ["tuiTextfield", ""];
let TuiValueDecorationComponent = /*#__PURE__*/(() => {
  class TuiValueDecorationComponent {
    constructor(textfield, fontsReady$) {
      this.textfield = textfield;
      this.fontsReady$ = fontsReady$;
      this.prefix$ = new BehaviorSubject('');
      this.pre$ = merge(this.fontsReady$, this.prefix$).pipe(delay(0), filter(() => {
        var _a;
        return !!((_a = this.pre) === null || _a === void 0 ? void 0 : _a.nativeElement.isConnected);
      }), map(() => {
        var _a;
        return ((_a = this.pre) === null || _a === void 0 ? void 0 : _a.nativeElement.offsetWidth) || 0;
      }), distinctUntilChanged());
    }
    get isContextTable() {
      return this.textfield.appearance === TuiAppearance.Table;
    }
    get value() {
      return this.textfield.value;
    }
    get filler() {
      const {
        focused,
        placeholder,
        exampleText,
        value,
        textfield
      } = this;
      if (placeholder && exampleText) {
        return '';
      }
      return focused ? exampleText || textfield.filler.slice(value.length) : '';
    }
    get prefix() {
      return this.decorationsVisible ? this.textfield.prefix : '';
    }
    get postfix() {
      return this.decorationsVisible ? this.computedPostfix : '';
    }
    ngDoCheck() {
      this.prefix$.next(this.prefix);
    }
    get placeholder() {
      var _a;
      return ((_a = this.textfield.nativeFocusableElement) === null || _a === void 0 ? void 0 : _a.placeholder) || '';
    }
    get exampleText() {
      return !this.value && this.focused ? this.placeholder : '';
    }
    get decorationsVisible() {
      return !!this.value || this.focused && !this.placeholder;
    }
    get focused() {
      return this.textfield.computedFocused && !this.textfield.readOnly;
    }
    get computedPostfix() {
      return this.textfield.postfix && (this.filler || this.value) ? ` ${this.textfield.postfix}` : this.textfield.postfix;
    }
  }
  TuiValueDecorationComponent.ɵfac = function TuiValueDecorationComponent_Factory(t) {
    return new (t || TuiValueDecorationComponent)(i0.ɵɵdirectiveInject(TUI_FOCUSABLE_ITEM_ACCESSOR), i0.ɵɵdirectiveInject(TUI_FONTS_READY));
  };
  TuiValueDecorationComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiValueDecorationComponent,
    selectors: [["tui-value-decoration"]],
    viewQuery: function TuiValueDecorationComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7, ElementRef);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pre = _t.first);
      }
    },
    hostVars: 4,
    hostBindings: function TuiValueDecorationComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("animationstart", function TuiValueDecorationComponent_animationstart_HostBindingHandler() {
          return ctx.ngDoCheck();
        });
      }
      if (rf & 2) {
        i0.ɵɵclassProp("_table", ctx.isContextTable)("_filler", ctx.filler);
      }
    },
    decls: 5,
    vars: 4,
    consts: [["pre", ""], [1, "t-prefix", 3, "textContent"], [1, "t-ghost", 3, "textContent"], [1, "t-filler", 3, "textContent"], [1, "t-postfix", 3, "textContent"]],
    template: function TuiValueDecorationComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelement(0, "span", 1, 0)(2, "span", 2)(3, "span", 3)(4, "span", 4);
      }
      if (rf & 2) {
        i0.ɵɵproperty("textContent", ctx.prefix);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("textContent", ctx.value);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", ctx.filler);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", ctx.postfix);
      }
    },
    styles: ["[_nghost-%COMP%]{position:absolute;display:block;width:100%;line-height:var(--tui-height);margin-top:calc(var(--tui-height) / -2);box-sizing:content-box;color:var(--tui-text-03);animation:tuiPresent 1s;white-space:nowrap}._table[_nghost-%COMP%]{position:static;margin-top:0}._filler[_nghost-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}tui-primitive-textfield   [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]{color:var(--tui-text-03-night)}tui-primitive-textfield[data-size=\"m\"]:not(._label-outside)   [_nghost-%COMP%]{line-height:calc(var(--tui-height) - .25rem)}.t-ghost[_ngcontent-%COMP%]{visibility:hidden;white-space:pre;text-overflow:clip}.t-prefix[_ngcontent-%COMP%], .t-postfix[_ngcontent-%COMP%]{white-space:pre;color:var(--tui-text-01)}tui-primitive-textfield   [tuiWrapper][data-mode=\"onDark\"][_nghost-%COMP%]   .t-prefix[_ngcontent-%COMP%], tui-primitive-textfield   [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]   .t-prefix[_ngcontent-%COMP%], tui-primitive-textfield   [tuiWrapper][data-mode=\"onDark\"][_nghost-%COMP%]   .t-postfix[_ngcontent-%COMP%], tui-primitive-textfield   [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]   .t-postfix[_ngcontent-%COMP%]{color:var(--tui-text-01-night)}.t-filler[_ngcontent-%COMP%]{max-width:100%;white-space:nowrap}"]
  });
  return TuiValueDecorationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TUI_ICON_PADDINGS = {
  s: 1.25,
  m: 1.75,
  l: 2.25
};
let TuiPrimitiveTextfieldComponent = /*#__PURE__*/(() => {
  class TuiPrimitiveTextfieldComponent extends AbstractTuiInteractive {
    constructor(controller, hintOptions, options, el) {
      super();
      this.controller = controller;
      this.hintOptions = hintOptions;
      this.options = options;
      this.el = el;
      this.editable = true;
      /** @deprecated use `tuiTextfieldFiller` from {@link TuiTextfieldControllerModule} instead */
      this.textfieldFiller = '';
      /**
       * @deprecated:
       * use `tuiTextfieldOptionsProvider({iconCleaner: `tuiIconChevronUp`})`
       */
      this.iconCleaner = this.options.iconCleaner;
      this.readOnly = false;
      this.invalid = false;
      this.disabled = false;
      /** @deprecated use `tuiTextfieldPrefix` from {@link TuiTextfieldControllerModule} instead */
      this.textfieldPrefix = '';
      /** @deprecated use `tuiTextfieldPostfix` from {@link TuiTextfieldControllerModule} instead */
      this.textfieldPostfix = '';
      this.value = '';
      this.valueChange = new EventEmitter();
      this.autofilled = false;
    }
    get prefix() {
      return this.textfieldPrefix || this.controller.prefix;
    }
    get postfix() {
      return this.textfieldPostfix || this.controller.postfix;
    }
    get filler() {
      return this.textfieldFiller || this.controller.filler;
    }
    get nativeFocusableElement() {
      if (this.computedDisabled || !this.focusableElement) {
        return null;
      }
      const {
        nativeElement
      } = this.focusableElement;
      return nativeElement.previousElementSibling || nativeElement;
    }
    get focused() {
      return tuiIsNativeFocusedIn(this.el.nativeElement);
    }
    get appearance() {
      return this.controller.appearance;
    }
    get size() {
      return this.controller.size;
    }
    get computedInvalid() {
      return !this.readOnly && !this.disabled && this.invalid;
    }
    get inputHidden() {
      var _a;
      return !!((_a = this.content) === null || _a === void 0 ? void 0 : _a.length);
    }
    get hasValue() {
      return !!this.value;
    }
    get hasCleaner() {
      return this.controller.cleaner && this.hasValue && !this.computedDisabled && !this.readOnly;
    }
    get hasTooltip() {
      var _a;
      return !!((_a = this.hintOptions) === null || _a === void 0 ? void 0 : _a.content) && !this.computedDisabled;
    }
    get hasCustomContent() {
      return !!this.controller.customContent;
    }
    get placeholderVisible() {
      var _a;
      const hasDecor = ((_a = this.nativeFocusableElement) === null || _a === void 0 ? void 0 : _a.placeholder) || this.prefix || this.postfix || this.filler;
      const showDecor = hasDecor && !this.readOnly && this.computedFocused;
      return !this.hasValue && !showDecor;
    }
    get hasPlaceholder() {
      return this.placeholderRaisable || this.placeholderVisible;
    }
    get placeholderRaised() {
      return this.placeholderRaisable && (this.computedFocused && !this.readOnly || this.hasValue || this.autofilled);
    }
    get borderStart() {
      return this.iconLeftContent ? this.iconPaddingLeft : 0;
    }
    get borderEnd() {
      return tuiGetBorder(!!this.iconContent, this.hasCleaner, this.hasTooltip, this.hasCustomContent, this.size);
    }
    get iconContent() {
      return this.controller.icon;
    }
    get iconLeftContent() {
      return this.controller.iconLeft;
    }
    get showHint() {
      var _a;
      return !!((_a = this.hintOptions) === null || _a === void 0 ? void 0 : _a.content) && (this.options.hintOnDisabled || !this.computedDisabled);
    }
    // Safari expiration date autofill workaround
    get name() {
      var _a;
      return ((_a = this.nativeFocusableElement) === null || _a === void 0 ? void 0 : _a.autocomplete) === 'cc-exp' ? 'ccexpiryyear' : null;
    }
    get computedId() {
      var _a;
      return ((_a = this.nativeFocusableElement) === null || _a === void 0 ? void 0 : _a.id) || '';
    }
    onFocused(focused) {
      this.updateFocused(focused);
    }
    getIndent$(element) {
      return fromEvent(element, 'scroll').pipe(map(() => -1 * Math.max(element.scrollLeft, 0)));
    }
    clear() {
      if (this.nativeFocusableElement) {
        this.nativeFocusableElement.value = '';
      }
      this.updateValue('');
    }
    onMouseDown(event) {
      const {
        nativeFocusableElement
      } = this;
      if (!nativeFocusableElement || event.target === nativeFocusableElement) {
        return;
      }
      event.preventDefault();
      nativeFocusableElement.focus();
    }
    onModelChange(value) {
      this.updateValue(value);
    }
    onAutofilled(autofilled) {
      this.updateAutofilled(autofilled);
    }
    detectRetargetFromLabel(event) {
      if (tuiRetargetedBoundaryCrossing(event)) {
        event.stopImmediatePropagation();
      }
    }
    get iconPaddingLeft() {
      return TUI_ICON_PADDINGS[this.size];
    }
    get placeholderRaisable() {
      return this.size !== 's' && !this.controller.labelOutside;
    }
    updateAutofilled(autofilled) {
      if (this.autofilled === autofilled) {
        return;
      }
      this.autofilled = autofilled;
    }
    updateValue(value) {
      this.value = value;
      this.valueChange.emit(value);
    }
  }
  TuiPrimitiveTextfieldComponent.ɵfac = function TuiPrimitiveTextfieldComponent_Factory(t) {
    return new (t || TuiPrimitiveTextfieldComponent)(i0.ɵɵdirectiveInject(TUI_TEXTFIELD_WATCHED_CONTROLLER), i0.ɵɵdirectiveInject(TuiHintOptionsDirective, 8), i0.ɵɵdirectiveInject(TUI_TEXTFIELD_OPTIONS), i0.ɵɵdirectiveInject(ElementRef));
  };
  TuiPrimitiveTextfieldComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiPrimitiveTextfieldComponent,
    selectors: [["tui-primitive-textfield"]],
    contentQueries: function TuiPrimitiveTextfieldComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, PolymorpheusOutletDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t);
      }
    },
    viewQuery: function TuiPrimitiveTextfieldComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c1, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.focusableElement = _t.first);
      }
    },
    hostVars: 15,
    hostBindings: function TuiPrimitiveTextfieldComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("focusin", function TuiPrimitiveTextfieldComponent_focusin_HostBindingHandler() {
          return ctx.onFocused(true);
        })("focusout", function TuiPrimitiveTextfieldComponent_focusout_HostBindingHandler() {
          return ctx.onFocused(false);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("data-size", ctx.size);
        i0.ɵɵstyleProp("--border-start", ctx.borderStart, "rem")("--border-end", ctx.borderEnd, "rem");
        i0.ɵɵclassProp("_autofilled", ctx.autofilled)("_label-outside", ctx.controller.labelOutside)("_readonly", ctx.readOnly)("_invalid", ctx.computedInvalid)("_hidden", ctx.inputHidden);
      }
    },
    inputs: {
      editable: "editable",
      textfieldFiller: [i0.ɵɵInputFlags.None, "filler", "textfieldFiller"],
      iconCleaner: "iconCleaner",
      readOnly: "readOnly",
      invalid: "invalid",
      disabled: "disabled",
      textfieldPrefix: [i0.ɵɵInputFlags.None, "prefix", "textfieldPrefix"],
      textfieldPostfix: [i0.ɵɵInputFlags.None, "postfix", "textfieldPostfix"],
      value: "value"
    },
    outputs: {
      valueChange: "valueChange"
    },
    features: [i0.ɵɵProvidersFeature([tuiAsFocusableItemAccessor(TuiPrimitiveTextfieldComponent), TEXTFIELD_CONTROLLER_PROVIDER]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c3,
    decls: 24,
    vars: 37,
    consts: [["focusableElement", ""], ["decor", ""], [4, "ngIf"], ["automation-id", "tui-primitive-textfield__wrapper", "tuiWrapper", "", 3, "click.prevent.silent", "mousedown", "tuiAutofilledChange", "active", "appearance", "disabled", "focus", "hover", "invalid", "readOnly"], ["automation-id", "tui-primitive-textfield__native-input", "tuiMaskAccessor", "", 1, "t-input", 3, "ngModelChange", "disabled", "id", "ngModel", "readOnly", "tuiFocusable"], ["automation-id", "tui-primitive-textfield__value", "class", "t-input t-input_template", 4, "ngIf"], [1, "t-content"], ["class", "t-icon t-icon_left t-textfield-icon", 4, "ngIf"], [1, "t-wrapper"], ["automation-id", "tui-primitive-textfield__placeholder", "class", "t-placeholder", 3, "t-placeholder_raised", "for", 4, "ngIf"], [1, "t-wrapper-value-decoration"], ["aria-hidden", "true", "automation-id", "tui-primitive-textfield__value-decoration", 1, "t-value-decoration"], [1, "t-icons"], ["automation-id", "tui-primitive-textfield__custom-content", "class", "t-custom-content", 4, "ngIf"], ["appearance", "icon", "automation-id", "tui-primitive-textfield__cleaner", "tuiWrapper", "", "class", "t-cleaner", 3, "click.stop", 4, "ngIf"], ["automation-id", "tui-primitive-textfield__tooltip", "class", "t-tooltip", 3, "content", "describeId", 4, "ngIf"], ["class", "t-icon t-textfield-icon", 4, "ngIf"], ["automation-id", "tui-primitive-textfield__value", 1, "t-input", "t-input_template"], [1, "t-icon", "t-icon_left", "t-textfield-icon"], ["appearance", "icon", "tuiWrapper", "", 3, "src", 4, "polymorpheusOutlet", "polymorpheusOutletContext"], ["appearance", "icon", "tuiWrapper", "", 3, "src"], ["automation-id", "tui-primitive-textfield__placeholder", 1, "t-placeholder", 3, "for"], ["automation-id", "tui-primitive-textfield__custom-content", 1, "t-custom-content"], ["class", "t-custom-icon", 3, "src", 4, "polymorpheusOutlet"], [1, "t-custom-icon", 3, "src"], ["appearance", "icon", "automation-id", "tui-primitive-textfield__cleaner", "tuiWrapper", "", 1, "t-cleaner", 3, "click.stop"], [3, "src", 4, "polymorpheusOutlet", "polymorpheusOutletContext"], [3, "src"], ["automation-id", "tui-primitive-textfield__tooltip", 1, "t-tooltip", 3, "content", "describeId"], [1, "t-icon", "t-textfield-icon"]],
    template: function TuiPrimitiveTextfieldComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef(_c2);
        i0.ɵɵtemplate(0, TuiPrimitiveTextfieldComponent_ng_container_0_Template, 1, 0, "ng-container", 2);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, TuiPrimitiveTextfieldComponent_ng_container_2_Template, 1, 0, "ng-container", 2);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵpipe(5, "async");
        i0.ɵɵlistener("click.prevent.silent", function TuiPrimitiveTextfieldComponent_Template_div_click_prevent_silent_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.detectRetargetFromLabel($event));
        })("mousedown", function TuiPrimitiveTextfieldComponent_Template_div_mousedown_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onMouseDown($event));
        })("tuiAutofilledChange", function TuiPrimitiveTextfieldComponent_Template_div_tuiAutofilledChange_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onAutofilled($event));
        });
        i0.ɵɵprojection(6);
        i0.ɵɵprojection(7, 1);
        i0.ɵɵelementStart(8, "input", 4, 0);
        i0.ɵɵlistener("ngModelChange", function TuiPrimitiveTextfieldComponent_Template_input_ngModelChange_8_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onModelChange($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, TuiPrimitiveTextfieldComponent_div_10_Template, 2, 0, "div", 5);
        i0.ɵɵelementStart(11, "div", 6);
        i0.ɵɵtemplate(12, TuiPrimitiveTextfieldComponent_div_12_Template, 2, 4, "div", 7);
        i0.ɵɵelementStart(13, "div", 8);
        i0.ɵɵtemplate(14, TuiPrimitiveTextfieldComponent_label_14_Template, 2, 3, "label", 9);
        i0.ɵɵelementStart(15, "div", 10);
        i0.ɵɵelement(16, "tui-value-decoration", 11, 1);
        i0.ɵɵpipe(18, "async");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(19, "div", 12);
        i0.ɵɵtemplate(20, TuiPrimitiveTextfieldComponent_div_20_Template, 2, 1, "div", 13)(21, TuiPrimitiveTextfieldComponent_span_21_Template, 2, 4, "span", 14)(22, TuiPrimitiveTextfieldComponent_tui_tooltip_22_Template, 1, 2, "tui-tooltip", 15)(23, TuiPrimitiveTextfieldComponent_div_23_Template, 2, 4, "div", 16);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        const focusableElement_r8 = i0.ɵɵreference(9);
        const decor_r9 = i0.ɵɵreference(17);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 29, ctx.content == null ? null : ctx.content.changes));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 31, ctx.hintOptions == null ? null : ctx.hintOptions.change$));
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("--text-indent", i0.ɵɵpipeBind1(5, 33, decor_r9.pre$), "px");
        i0.ɵɵproperty("active", ctx.pseudoActive)("appearance", ctx.appearance)("disabled", ctx.disabled)("focus", ctx.computedFocused)("hover", ctx.pseudoHover)("invalid", ctx.computedInvalid)("readOnly", ctx.readOnly);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", ctx.computedDisabled)("id", ctx.id)("ngModel", ctx.value)("readOnly", ctx.readOnly || !ctx.editable)("tuiFocusable", ctx.computedFocusable);
        i0.ɵɵattribute("aria-invalid", ctx.computedInvalid)("name", ctx.name);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.inputHidden);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.iconLeftContent);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.hasPlaceholder);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("text-indent", i0.ɵɵpipeBind1(18, 35, ctx.getIndent$(focusableElement_r8)), "px");
        i0.ɵɵclassProp("t-has-value", ctx.value);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.hasCustomContent);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.hasCleaner);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showHint);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.iconContent);
      }
    },
    dependencies: [i1.TuiSvgComponent, TuiValueDecorationComponent, i3.TuiTooltipComponent, i4.NgIf, i5.TuiWrapperDirective, i6.TuiAutofilledDirective, i7.TuiMaskAccessorDirective, i8.DefaultValueAccessor, i8.NgControlStatus, i8.NgModel, i6.TuiFocusableDirective, i9.PolymorpheusOutletDirective, i4.AsyncPipe],
    styles: ["[_nghost-%COMP%]{font:var(--tui-font-text-s);color:var(--tui-text-01);position:relative;display:block;text-align:left;border-radius:var(--tui-radius-m);height:var(--tui-height);min-height:var(--tui-height);max-height:var(--tui-height)}[data-size=s][_nghost-%COMP%]{--tui-height: var(--tui-height-s)}[data-size=m][_nghost-%COMP%]{--tui-height: var(--tui-height-m)}[data-size=l][_nghost-%COMP%]{--tui-height: var(--tui-height-l);font:var(--tui-font-text-m);line-height:1.25rem}.t-input[_ngcontent-%COMP%]{font:var(--tui-font-text-s);color:var(--tui-text-01);padding:0;margin:0;border-width:0;border-radius:inherit;background:none;font-size:inherit;line-height:inherit;font-weight:inherit;color:inherit;caret-color:currentColor;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;word-break:keep-all;-webkit-text-fill-color:currentColor;position:absolute;top:0;left:0;width:100%;height:100%;border-style:solid;border-color:transparent;border-inline-start-width:var(--border-start, 0);border-inline-end-width:var(--border-end, 0);text-indent:var(--text-indent);text-align:inherit;box-sizing:border-box;white-space:nowrap;overflow:hidden;text-transform:inherit;resize:none}.t-input[_ngcontent-%COMP%]:-webkit-autofill, .t-input[_ngcontent-%COMP%]:-webkit-autofill:hover, .t-input[_ngcontent-%COMP%]:-webkit-autofill:focus{caret-color:var(--tui-base-09);border-radius:inherit;color:inherit!important;background-color:transparent!important;-webkit-text-fill-color:var(--tui-text-01)!important;border-color:var(--tui-autofill);-webkit-box-shadow:0 0 0 100rem var(--tui-autofill) inset!important}.t-input[_ngcontent-%COMP%]:-webkit-autofill, .t-input[_ngcontent-%COMP%]:-webkit-autofill:first-line{font-size:inherit;line-height:inherit}.t-input[_ngcontent-%COMP%]::-webkit-caps-lock-indicator, .t-input[_ngcontent-%COMP%]::-webkit-contacts-auto-fill-button, .t-input[_ngcontent-%COMP%]::-webkit-credit-card-auto-fill-button, .t-input[_ngcontent-%COMP%]::-webkit-credentials-auto-fill-button, .t-input[_ngcontent-%COMP%]::-webkit-strong-password-auto-fill-button{content:none!important;position:absolute;left:-62.4375rem;top:-62.4375rem;z-index:-999;display:none!important;background:transparent!important;pointer-events:none!important}.t-input[_ngcontent-%COMP%]::placeholder{color:var(--tui-text-03);opacity:0}._focused[_nghost-%COMP%]:not(._readonly)   .t-input[_ngcontent-%COMP%]::placeholder, tui-primitive-textfield._focused:not(._readonly)[_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, tui-primitive-textfield._focused:not(._readonly)   [_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, tui-textarea._focused:not(._readonly)[_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, tui-textarea._focused:not(._readonly)   [_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, tui-text-area._focused:not(._readonly)[_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, tui-text-area._focused:not(._readonly)   [_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder{opacity:1}[tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-input[_ngcontent-%COMP%]:-webkit-autofill, .t-input   [tuiWrapper][data-mode=\"onDark\"][_nghost-%COMP%]:-webkit-autofill, [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]:-webkit-autofill, [tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-input[_ngcontent-%COMP%]:-webkit-autofill:hover, .t-input   [tuiWrapper][data-mode=\"onDark\"][_nghost-%COMP%]:-webkit-autofill:hover, [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]:-webkit-autofill:hover, [tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-input[_ngcontent-%COMP%]:-webkit-autofill:focus, .t-input   [tuiWrapper][data-mode=\"onDark\"][_nghost-%COMP%]:-webkit-autofill:focus, [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]:-webkit-autofill:focus{caret-color:var(--tui-base-09);border-radius:inherit;color:inherit!important;background-color:transparent!important;-webkit-text-fill-color:var(--tui-text-01-night)!important;border-color:var(--tui-autofill-night);-webkit-box-shadow:0 0 0 100rem var(--tui-autofill-night) inset!important}[tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, .t-input   [tuiWrapper][data-mode=\"onDark\"][_nghost-%COMP%]::placeholder, [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]::placeholder{color:var(--tui-text-03-night)}[data-size=s][_nghost-%COMP%]   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield[data-size=\"s\"][_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"s\"]   [_nghost-%COMP%]:not(tui-primitive-textfield), .t-input   tui-textarea[data-size=\"s\"][_nghost-%COMP%]:not(tui-textarea), tui-textarea[data-size=\"s\"]   [_nghost-%COMP%]:not(tui-textarea), .t-input   tui-text-area[data-size=\"s\"][_nghost-%COMP%]:not(tui-text-area), tui-text-area[data-size=\"s\"]   [_nghost-%COMP%]:not(tui-text-area){padding:0 var(--tui-padding-s)}[data-size=m][_nghost-%COMP%]   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield[data-size=\"m\"][_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"m\"]   [_nghost-%COMP%]:not(tui-primitive-textfield), .t-input   tui-textarea[data-size=\"m\"][_nghost-%COMP%]:not(tui-textarea), tui-textarea[data-size=\"m\"]   [_nghost-%COMP%]:not(tui-textarea), .t-input   tui-text-area[data-size=\"m\"][_nghost-%COMP%]:not(tui-text-area), tui-text-area[data-size=\"m\"]   [_nghost-%COMP%]:not(tui-text-area){padding:0 var(--tui-padding-m)}[data-size=l][_nghost-%COMP%]   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield[data-size=\"l\"][_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"l\"]   [_nghost-%COMP%]:not(tui-primitive-textfield), .t-input   tui-textarea[data-size=\"l\"][_nghost-%COMP%]:not(tui-textarea), tui-textarea[data-size=\"l\"]   [_nghost-%COMP%]:not(tui-textarea), .t-input   tui-text-area[data-size=\"l\"][_nghost-%COMP%]:not(tui-text-area), tui-text-area[data-size=\"l\"]   [_nghost-%COMP%]:not(tui-text-area){padding:0 var(--tui-padding-l)}._disabled[_nghost-%COMP%]   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield._disabled[_nghost-%COMP%], tui-primitive-textfield._disabled   [_nghost-%COMP%], .t-input   tui-textarea._disabled[_nghost-%COMP%], tui-textarea._disabled   [_nghost-%COMP%], .t-input   tui-text-area._disabled[_nghost-%COMP%], tui-text-area._disabled   [_nghost-%COMP%]{pointer-events:none}[data-size=l][_nghost-%COMP%]:not(._label-outside)   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield[data-size=\"l\"]:not(._label-outside)[_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"l\"]:not(._label-outside)   [_nghost-%COMP%]:not(tui-primitive-textfield){padding-top:1.25rem}[data-size=m][_nghost-%COMP%]:not(._label-outside)   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield[data-size=\"m\"]:not(._label-outside)[_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"m\"]:not(._label-outside)   [_nghost-%COMP%]:not(tui-primitive-textfield){padding-top:1rem}[data-size=l][_nghost-%COMP%]:not(._label-outside)   .t-input[_ngcontent-%COMP%]{padding-top:1.25rem}[data-size=l][_nghost-%COMP%]:not(._label-outside)   .t-input[_ngcontent-%COMP%]:-webkit-autofill + .t-content[_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{font-size:.8156rem;transform:translateY(-.625rem)}[data-size=m][_nghost-%COMP%]:not(._label-outside)   .t-input[_ngcontent-%COMP%]:-webkit-autofill + .t-content[_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{font-size:.69rem;transform:translateY(-.5rem)}._hidden[_nghost-%COMP%]   input.t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield._hidden[_nghost-%COMP%], tui-primitive-textfield._hidden   [_nghost-%COMP%]{opacity:0;text-indent:-10em;-webkit-user-select:none}.t-content[_ngcontent-%COMP%]{display:flex;height:100%;width:100%;box-sizing:border-box;align-items:center;overflow:hidden}[data-size=s][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding:0 var(--tui-padding-s)}[data-size=m][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding:0 var(--tui-padding-m)}[data-size=l][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding:0 var(--tui-padding-l)}.t-wrapper[_ngcontent-%COMP%]{flex:1;min-width:0;-webkit-padding-end:.25rem;padding-inline-end:.25rem}.t-placeholder[_ngcontent-%COMP%]{transition-property:transform,font-size,color,letter-spacing;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;width:100%;-webkit-user-select:none;-moz-user-select:none;user-select:none;font:var(--tui-font-text-s);color:var(--tui-text-02);pointer-events:none;will-change:transform;transform:translateY(0)}@supports (-webkit-hyphens: none){.t-placeholder[_ngcontent-%COMP%]{will-change:unset;transition-property:transform,color,letter-spacing}}.t-placeholder_raised[_ngcontent-%COMP%]{transform:translateY(-.625rem)}[data-size=m][_nghost-%COMP%]   .t-placeholder_raised[_ngcontent-%COMP%]{font:var(--tui-font-text-xs);line-height:1.25rem;transform:translateY(-.5rem);letter-spacing:.025rem}._invalid[_nghost-%COMP%]:not(._focused)   .t-placeholder_raised[_ngcontent-%COMP%], ._invalid[_nghost-%COMP%]:not(._focused):hover   .t-placeholder_raised[_ngcontent-%COMP%]{color:var(--tui-error-fill)}._invalid[_nghost-%COMP%]:not(._focused)   [tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-placeholder_raised[_ngcontent-%COMP%], ._invalid[_nghost-%COMP%]:not(._focused):hover   [tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-placeholder_raised[_ngcontent-%COMP%]{color:var(--tui-error-fill-night)}._focused[_nghost-%COMP%]   .t-placeholder[_ngcontent-%COMP%], [data-size=m]._focused._label-outside[_nghost-%COMP%]   .t-placeholder[_ngcontent-%COMP%], [data-size=l]._focused._label-outside[_nghost-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{color:var(--tui-text-03)}[data-size=l][_nghost-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{font:var(--tui-font-text-m);line-height:1.25rem}[data-size=l][_nghost-%COMP%]   .t-placeholder_raised[_ngcontent-%COMP%]{font-size:.8156rem}[data-size=m]._focused[_nghost-%COMP%]:not(._label-outside)   .t-placeholder[_ngcontent-%COMP%], [data-size=l]._focused[_nghost-%COMP%]:not(._label-outside)   .t-placeholder[_ngcontent-%COMP%]{color:var(--tui-text-01)}[tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{color:var(--tui-text-02-night)}[data-size=m]._focused[_nghost-%COMP%]:not(._label-outside)   [tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%], [data-size=l]._focused[_nghost-%COMP%]:not(._label-outside)   [tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{color:var(--tui-text-01-night)}._focused[_nghost-%COMP%]   [tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%], [data-size=m]._focused._label-outside[_nghost-%COMP%]   [tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%], [data-size=l]._focused._label-outside[_nghost-%COMP%]   [tuiWrapper][data-mode=onDark][_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{color:var(--tui-text-02-night)}.t-cleaner[_ngcontent-%COMP%]{position:relative;display:flex;width:1.5rem;height:1.5rem;align-items:center;justify-content:center;box-sizing:border-box;cursor:pointer;pointer-events:none;pointer-events:auto}._readonly[_nghost-%COMP%]   .t-cleaner[_ngcontent-%COMP%], ._disabled[_nghost-%COMP%]   .t-cleaner[_ngcontent-%COMP%]{pointer-events:none}.t-icon[_ngcontent-%COMP%]{position:relative;display:flex;width:1.5rem;height:1.5rem;align-items:center;justify-content:center;box-sizing:border-box;cursor:pointer;pointer-events:none}[data-size=s][_nghost-%COMP%]   .t-icon_left[_ngcontent-%COMP%]{-webkit-margin-start:-.375rem;margin-inline-start:-.375rem}[data-size=m][_nghost-%COMP%]   .t-icon_left[_ngcontent-%COMP%]{-webkit-margin-start:-.125rem;margin-inline-start:-.125rem;-webkit-margin-end:.375rem;margin-inline-end:.375rem}[data-size=l][_nghost-%COMP%]   .t-icon_left[_ngcontent-%COMP%]{-webkit-margin-end:.75rem;margin-inline-end:.75rem}.t-icons[_ngcontent-%COMP%]{display:flex;align-items:center}[data-size=m][_nghost-%COMP%]   .t-icons[_ngcontent-%COMP%]{-webkit-margin-end:-.125rem;margin-inline-end:-.125rem}[data-size=s][_nghost-%COMP%]   .t-icons[_ngcontent-%COMP%]{-webkit-margin-end:-.375rem;margin-inline-end:-.375rem}[_nghost-%COMP%]:not([data-size=\"s\"])   .t-icons[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:not(:first-child){-webkit-margin-start:.25rem;margin-inline-start:.25rem}._autofilled[data-size=s][_nghost-%COMP%]   .t-placeholder[_ngcontent-%COMP%], ._autofilled._label-outside[_nghost-%COMP%]   .t-placeholder[_ngcontent-%COMP%], ._autofilled[_nghost-%COMP%]   .t-value-decoration[_ngcontent-%COMP%]:not(.t-has-value){visibility:hidden}.t-custom-content[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center;justify-content:center;min-width:2rem;height:2rem;pointer-events:none}.t-custom-icon[_ngcontent-%COMP%]{width:2rem;height:100%}.t-input[_ngcontent-%COMP%]:not(:first-child){display:none}[data-size][_nghost-%COMP%]   .t-input_template[_ngcontent-%COMP%]{display:flex;width:calc(100% - 1rem);max-width:calc(100% - 1rem);align-items:center;pointer-events:none;-webkit-padding-end:0;padding-inline-end:0}.t-text-template[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.t-wrapper-value-decoration[_ngcontent-%COMP%]{position:relative;pointer-events:none}"],
    changeDetection: 0
  });
  __decorate([tuiPure], TuiPrimitiveTextfieldComponent.prototype, "getIndent$", null);
  return TuiPrimitiveTextfieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiPrimitiveTextfieldDirective = /*#__PURE__*/(() => {
  class TuiPrimitiveTextfieldDirective extends AbstractTuiTextfieldHost {
    constructor(textfield) {
      /**
       * TuiPrimitiveTextfieldComponent satisfies all required parts of
       * AbstractTuiControl interface. A new interface is not introduced
       * so AbstractTuiControl is automatically injected for all other controls.
       */
      super(textfield);
      this.textfield = textfield;
    }
    get readOnly() {
      return this.textfield.readOnly || !this.textfield.editable;
    }
    onValueChange(value) {
      this.textfield.onModelChange(value);
    }
  }
  TuiPrimitiveTextfieldDirective.ɵfac = function TuiPrimitiveTextfieldDirective_Factory(t) {
    return new (t || TuiPrimitiveTextfieldDirective)(i0.ɵɵdirectiveInject(TuiPrimitiveTextfieldComponent));
  };
  TuiPrimitiveTextfieldDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiPrimitiveTextfieldDirective,
    selectors: [["tui-primitive-textfield"]],
    features: [i0.ɵɵProvidersFeature([tuiAsTextfieldHost(TuiPrimitiveTextfieldDirective)]), i0.ɵɵInheritDefinitionFeature]
  });
  return TuiPrimitiveTextfieldDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTextfieldComponent = /*#__PURE__*/(() => {
  class TuiTextfieldComponent {
    constructor(host, controller, el, idService, legacyMask) {
      this.host = host;
      this.controller = controller;
      this.el = el;
      this.idService = idService;
      this.legacyMask = legacyMask;
      this.host.process(this.el.nativeElement);
    }
    get id() {
      return this.el.nativeElement.id || this.idService.generate();
    }
    get inputMode() {
      return this.el.nativeElement.inputMode || this.host.inputMode;
    }
  }
  TuiTextfieldComponent.ɵfac = function TuiTextfieldComponent_Factory(t) {
    return new (t || TuiTextfieldComponent)(i0.ɵɵdirectiveInject(TUI_TEXTFIELD_HOST), i0.ɵɵdirectiveInject(TUI_TEXTFIELD_WATCHED_CONTROLLER$1), i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(TuiIdService), i0.ɵɵdirectiveInject(TUI_LEGACY_MASK, 8));
  };
  TuiTextfieldComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiTextfieldComponent,
    selectors: [["input", "tuiTextfield", ""], ["textarea", "tuiTextfield", ""]],
    hostAttrs: ["type", "text"],
    hostVars: 7,
    hostBindings: function TuiTextfieldComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("input", function TuiTextfieldComponent_input_HostBindingHandler($event) {
          return !ctx.legacyMask && ctx.host.onValueChange($event.target.value);
        });
      }
      if (rf & 2) {
        i0.ɵɵhostProperty("tabIndex", ctx.host.focusable ? 0 : -1)("readOnly", ctx.host.readOnly)("value", ctx.host.value);
        i0.ɵɵattribute("id", ctx.id)("inputMode", ctx.inputMode)("aria-invalid", ctx.host.invalid)("disabled", ctx.host.disabled || null);
      }
    },
    features: [i0.ɵɵProvidersFeature([TEXTFIELD_CONTROLLER_PROVIDER$1])],
    attrs: _c5,
    decls: 0,
    vars: 0,
    template: function TuiTextfieldComponent_Template(rf, ctx) {},
    styles: ["[_nghost-%COMP%]{font:var(--tui-font-text-s);color:var(--tui-text-01);padding:0;margin:0;border-width:0;border-radius:inherit;background:none;font-size:inherit;line-height:inherit;font-weight:inherit;color:inherit;caret-color:currentColor;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;word-break:keep-all;-webkit-text-fill-color:currentColor;position:absolute;top:0;left:0;width:100%;height:100%;border-style:solid;border-color:transparent;border-inline-start-width:var(--border-start, 0);border-inline-end-width:var(--border-end, 0);text-indent:var(--text-indent);text-align:inherit;box-sizing:border-box;white-space:nowrap;overflow:hidden;text-transform:inherit;resize:none}[_nghost-%COMP%]:-webkit-autofill, [_nghost-%COMP%]:-webkit-autofill:hover, [_nghost-%COMP%]:-webkit-autofill:focus{caret-color:var(--tui-base-09);border-radius:inherit;color:inherit!important;background-color:transparent!important;-webkit-text-fill-color:var(--tui-text-01)!important;border-color:var(--tui-autofill);-webkit-box-shadow:0 0 0 100rem var(--tui-autofill) inset!important}[_nghost-%COMP%]:-webkit-autofill, [_nghost-%COMP%]:-webkit-autofill:first-line{font-size:inherit;line-height:inherit}[_nghost-%COMP%]::-webkit-caps-lock-indicator, [_nghost-%COMP%]::-webkit-contacts-auto-fill-button, [_nghost-%COMP%]::-webkit-credit-card-auto-fill-button, [_nghost-%COMP%]::-webkit-credentials-auto-fill-button, [_nghost-%COMP%]::-webkit-strong-password-auto-fill-button{content:none!important;position:absolute;left:-62.4375rem;top:-62.4375rem;z-index:-999;display:none!important;background:transparent!important;pointer-events:none!important}[_nghost-%COMP%]::placeholder{color:var(--tui-text-03);opacity:0}._focused[_nghost-%COMP%]:not(._readonly)   [_ngcontent-%COMP%]::placeholder, tui-primitive-textfield._focused:not(._readonly)   [_nghost-%COMP%]::placeholder, tui-textarea._focused:not(._readonly)   [_nghost-%COMP%]::placeholder, tui-text-area._focused:not(._readonly)   [_nghost-%COMP%]::placeholder{opacity:1}[tuiWrapper][data-mode=onDark]   [_nghost-%COMP%]:-webkit-autofill, [_nghost-%COMP%]   [tuiWrapper][data-mode=\"onDark\"][_nghost-%COMP%]:-webkit-autofill, [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]:-webkit-autofill, [tuiWrapper][data-mode=onDark]   [_nghost-%COMP%]:-webkit-autofill:hover, [_nghost-%COMP%]   [tuiWrapper][data-mode=\"onDark\"][_nghost-%COMP%]:-webkit-autofill:hover, [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]:-webkit-autofill:hover, [tuiWrapper][data-mode=onDark]   [_nghost-%COMP%]:-webkit-autofill:focus, [_nghost-%COMP%]   [tuiWrapper][data-mode=\"onDark\"][_nghost-%COMP%]:-webkit-autofill:focus, [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]:-webkit-autofill:focus{caret-color:var(--tui-base-09);border-radius:inherit;color:inherit!important;background-color:transparent!important;-webkit-text-fill-color:var(--tui-text-01-night)!important;border-color:var(--tui-autofill-night);-webkit-box-shadow:0 0 0 100rem var(--tui-autofill-night) inset!important}[tuiWrapper][data-mode=onDark]   [_nghost-%COMP%]::placeholder, [_nghost-%COMP%]   [tuiWrapper][data-mode=\"onDark\"][_nghost-%COMP%]::placeholder, [tuiWrapper][data-mode=\"onDark\"]   [_nghost-%COMP%]::placeholder{color:var(--tui-text-03-night)}[data-size=s][_nghost-%COMP%]   -shadowcsshost, [_nghost-%COMP%]   tui-primitive-textfield[data-size=\"s\"][_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"s\"]   [_nghost-%COMP%]:not(tui-primitive-textfield), [_nghost-%COMP%]   tui-textarea[data-size=\"s\"][_nghost-%COMP%]:not(tui-textarea), tui-textarea[data-size=\"s\"]   [_nghost-%COMP%]:not(tui-textarea), [_nghost-%COMP%]   tui-text-area[data-size=\"s\"][_nghost-%COMP%]:not(tui-text-area), tui-text-area[data-size=\"s\"]   [_nghost-%COMP%]:not(tui-text-area){padding:0 var(--tui-padding-s)}[data-size=m][_nghost-%COMP%]   -shadowcsshost, [_nghost-%COMP%]   tui-primitive-textfield[data-size=\"m\"][_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"m\"]   [_nghost-%COMP%]:not(tui-primitive-textfield), [_nghost-%COMP%]   tui-textarea[data-size=\"m\"][_nghost-%COMP%]:not(tui-textarea), tui-textarea[data-size=\"m\"]   [_nghost-%COMP%]:not(tui-textarea), [_nghost-%COMP%]   tui-text-area[data-size=\"m\"][_nghost-%COMP%]:not(tui-text-area), tui-text-area[data-size=\"m\"]   [_nghost-%COMP%]:not(tui-text-area){padding:0 var(--tui-padding-m)}[data-size=l][_nghost-%COMP%]   -shadowcsshost, [_nghost-%COMP%]   tui-primitive-textfield[data-size=\"l\"][_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"l\"]   [_nghost-%COMP%]:not(tui-primitive-textfield), [_nghost-%COMP%]   tui-textarea[data-size=\"l\"][_nghost-%COMP%]:not(tui-textarea), tui-textarea[data-size=\"l\"]   [_nghost-%COMP%]:not(tui-textarea), [_nghost-%COMP%]   tui-text-area[data-size=\"l\"][_nghost-%COMP%]:not(tui-text-area), tui-text-area[data-size=\"l\"]   [_nghost-%COMP%]:not(tui-text-area){padding:0 var(--tui-padding-l)}._disabled[_nghost-%COMP%]   -shadowcsshost, [_nghost-%COMP%]   tui-primitive-textfield._disabled[_nghost-%COMP%], tui-primitive-textfield._disabled   [_nghost-%COMP%], [_nghost-%COMP%]   tui-textarea._disabled[_nghost-%COMP%], tui-textarea._disabled   [_nghost-%COMP%], [_nghost-%COMP%]   tui-text-area._disabled[_nghost-%COMP%], tui-text-area._disabled   [_nghost-%COMP%]{pointer-events:none}[data-size=l][_nghost-%COMP%]:not(._label-outside)   -shadowcsshost, [_nghost-%COMP%]   tui-primitive-textfield[data-size=\"l\"]:not(._label-outside)[_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"l\"]:not(._label-outside)   [_nghost-%COMP%]:not(tui-primitive-textfield){padding-top:1.25rem}[data-size=m][_nghost-%COMP%]:not(._label-outside)   -shadowcsshost, [_nghost-%COMP%]   tui-primitive-textfield[data-size=\"m\"]:not(._label-outside)[_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"m\"]:not(._label-outside)   [_nghost-%COMP%]:not(tui-primitive-textfield){padding-top:1rem}[data-size=l][_nghost-%COMP%]:not(._label-outside)   -shadowcsshost{padding-top:1.25rem}[data-size=l][_nghost-%COMP%]:not(._label-outside)   [_ngcontent-%COMP%]:-webkit-autofill + .t-content[_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{font-size:.8156rem;transform:translateY(-.625rem)}[data-size=m][_nghost-%COMP%]:not(._label-outside)   [_ngcontent-%COMP%]:-webkit-autofill + .t-content[_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{font-size:.69rem;transform:translateY(-.5rem)}._hidden[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   tui-primitive-textfield._hidden[_nghost-%COMP%], tui-primitive-textfield._hidden   [_nghost-%COMP%]{opacity:0;text-indent:-10em;-webkit-user-select:none}textarea[_nghost-%COMP%]{white-space:pre-wrap}textarea[_nghost-%COMP%]   tui-textarea._ios[_nghost-%COMP%], tui-textarea._ios   [_nghost-%COMP%], textarea[_nghost-%COMP%]   tui-text-area._ios[_nghost-%COMP%], tui-text-area._ios   [_nghost-%COMP%]{padding-left:.8125rem}"],
    changeDetection: 0
  });
  return TuiTextfieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiPrimitiveTextfieldModule = /*#__PURE__*/(() => {
  class TuiPrimitiveTextfieldModule {}
  TuiPrimitiveTextfieldModule.ɵfac = function TuiPrimitiveTextfieldModule_Factory(t) {
    return new (t || TuiPrimitiveTextfieldModule)();
  };
  TuiPrimitiveTextfieldModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TuiPrimitiveTextfieldModule
  });
  TuiPrimitiveTextfieldModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, FormsModule, PolymorpheusModule, TuiMaskAccessorModule, TuiFocusableModule, TuiWrapperModule, TuiSvgModule, TuiTooltipModule, TuiAutofilledModule]]
  });
  return TuiPrimitiveTextfieldModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @deprecated:
 * use {@link TUI_TEXTFIELD_DEFAULT_OPTIONS}
 */
const TUI_PRIMITIVE_TEXTFIELD_DEFAULT_OPTIONS = TUI_TEXTFIELD_DEFAULT_OPTIONS;
/**
 * @deprecated:
 * use {@link TUI_TEXTFIELD_OPTIONS}
 */
const TUI_PRIMITIVE_TEXTFIELD_OPTIONS = TUI_TEXTFIELD_OPTIONS$1;
/**
 * @deprecated:
 * use {@link tuiTextfieldOptionsProvider}
 */
const tuiPrimitiveTextfieldOptionsProvider = tuiTextfieldOptionsProvider;

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_ICON_PADDINGS, TUI_PRIMITIVE_TEXTFIELD_DEFAULT_OPTIONS, TUI_PRIMITIVE_TEXTFIELD_OPTIONS, TuiPrimitiveTextfieldComponent, TuiPrimitiveTextfieldDirective, TuiPrimitiveTextfieldModule, TuiTextfieldComponent, TuiValueDecorationComponent, tuiPrimitiveTextfieldOptionsProvider };
